import React from 'react';
import './Tooltip.css';

export const Tooltip = ({ content, children }) => {
  return (
    <div className="tooltip-container">
      {children}
      <span className="tooltip-text">{content}</span>
    </div>
  );
}; 